import { ReactElement, useCallback, useEffect, useState } from 'react';

import { useConnection } from 'modules/auth/hooks/useConnection';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { EMPTY_MODAL_UNSTAKE_SUCCESS_STATE } from 'modules/liquidStaking/const';
import { useUnstakeAction } from 'modules/liquidStaking/hooks/useUnstakeAction';
import {
  IModalSuccessState,
  IModalUnstakeSuccessState,
} from 'modules/liquidStaking/types';

import { IUnstakeFormProps, UnstakeForm } from './UnstakeForm';

export function Unstake(): ReactElement | null {
  const [successState, setSuccessState] = useState<IModalUnstakeSuccessState>(
    EMPTY_MODAL_UNSTAKE_SUCCESS_STATE,
  );
  const { isSafeAccount } = useConnection();

  const { unstake, isLoading, setType, type, txHash } = useUnstakeAction();

  const { onOpen, isOpened } = useDialog<IModalSuccessState>(
    KnownDialogs.tabUnstakeSuccess,
  );
  useEffect(() => {
    if (!isLoading && txHash && !isOpened && !isSafeAccount) {
      onOpen({ ...successState, txHash });
    }
  }, [txHash, isLoading, isOpened, onOpen, successState, isSafeAccount]);

  const handleSubmit: IUnstakeFormProps['onSubmit'] = useCallback(
    ({ amount, receiveAmount }) => {
      void unstake(amount);
      setSuccessState({ inAmount: amount, outAmount: receiveAmount, type });
    },
    [type, unstake],
  );

  return (
    <UnstakeForm
      isSubmitLoading={isLoading}
      setType={setType}
      type={type}
      onSubmit={handleSubmit}
    />
  );
}
